import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

/** Shared by browser and SSR entry points — required for `date`/`number` pipes on prerender. */
export function bootstrapAppLocale(): void {
  registerLocaleData(localeEs);
}
